angular.module('qkr.coupon').controller('couponQRController', ($scope, coupon, $uibModalInstance) => {
    if (coupon) {
        $scope.coupon = coupon;
        $scope.qrCodeUrl = coupon.qrCodeUrl;
        $scope.name = coupon.name;
    }

    $scope.cancel = function() {
        $uibModalInstance.close();
    };
});


// WEBPACK FOOTER //
// ./src/coupons/controllers/coupon.qr.controller.js